import React from 'react';
import { SectionFade } from './ui/SectionFade';
import { CheckIcon, BookIcon, BookOpenIcon, AlertTriangleIcon, SmartphoneIcon, HomeIcon } from 'lucide-react';
const items = [{
  title: "El Manual 'Etiquetas Sin Mentiras' (PDF Full)",
  desc: 'La guía paso a paso para dominar el supermercado.',
  icon: BookIcon
}, {
  title: 'El Diccionario de los 60 Alias del Azúcar',
  desc: 'Para que nunca más te vendan jarabes disfrazados de salud.',
  icon: BookOpenIcon
}, {
  title: 'El Semáforo de Aceites Inflamatorios',
  desc: 'Identifica los aceites vegetales que causan tu fatiga crónica.',
  icon: AlertTriangleIcon
}, {
  title: 'Cheat Sheet de Bolsillo (Imprimible)',
  desc: 'La lista de los 20 ingredientes prohibidos para llevar en tu móvil o cartera.',
  icon: SmartphoneIcon
}, {
  title: 'Guía de Auditoría de Despensa',
  desc: 'Cómo limpiar tu cocina de impostores en menos de 30 minutos.',
  icon: HomeIcon
}];
export function Deliverables() {
  return <section className="py-24 px-4 bg-white text-brand-black" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <SectionFade data-id="element-14">
          <h2 className="font-bebas text-6xl md:text-8xl text-center mb-16 tracking-tight" data-id="element-15">
            LO QUE RECIBES{' '}
            <span className="text-brand-black bg-brand-neon px-4 inline-block transform -skew-x-6" data-id="element-16">
              HOY
            </span>
          </h2>
        </SectionFade>

        <div className="space-y-6" data-id="element-17">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <SectionFade key={index} delay={index * 0.1} data-id="element-18">
                <div className="flex flex-col md:flex-row items-start md:items-center gap-6 p-6 md:p-8 bg-gray-50 rounded-2xl border border-gray-200 hover:shadow-xl hover:border-brand-neon/50 transition-all group" data-id="element-19">
                  <div className="bg-brand-black text-brand-neon p-4 rounded-xl group-hover:scale-110 transition-transform" data-id="element-20">
                    <Icon size={32} data-id="element-21" />
                  </div>
                  <div className="flex-1" data-id="element-22">
                    <h3 className="font-bebas text-3xl md:text-4xl tracking-wide mb-2 flex items-center gap-3" data-id="element-23">
                      {item.title}
                      <CheckIcon className="text-green-600 hidden md:block" size={24} data-id="element-24" />
                    </h3>
                    <p className="text-gray-600 font-inter text-lg" data-id="element-25">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </SectionFade>;
        })}
        </div>
      </div>
    </section>;
}